import {Routes} from '@angular/router';
import {UserRouteAccessService} from '@core/auth/user-route-access-service';
import {KhuVucResolve} from '@entities/khu-vuc/khu-vuc.route';
import {EntityLocationsResolve} from '@entities/entity-location/entity-localtions.resolve';
import {EntityLocationPopupComponent} from '@entities/entity-location/entity-location-dialog/entity-location-dialog.component';

export const entityLocationRoutes: Routes = [
  {
    path: 'entity-locations/:id',
    canActivate: [UserRouteAccessService],
    component: EntityLocationPopupComponent,
    resolve: {
      entityLocations: EntityLocationsResolve,
      entity: KhuVucResolve,
    },
    data: {
      pageTitle:
        'entities.entity-location.entity-location.Danh sách tọa độ khu vực_title',
      authorities: [
        'can_detail_unit_managerment',
        'can_update_unit_managerment',
      ],
    },
  },
];
